// angular
import { Injectable } from '@angular/core';

// i18n
import {  TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';
import { generateClassPrefix } from '@windmillcode/wml-components-base';


@Injectable({
  providedIn: 'root',

})
export class UtilityService {

  constructor(
    public translateService: TranslateService,
    public router:Router,
    public route:ActivatedRoute

  ) { }

  isIframe = window !== window.parent && !window.opener;
  currentLang = "global.langAbbreviations.0"
  changeLanguage(langCode:string){
    this.translateService.use(langCode)
  }

  /**
   * @deprecated use the export from @windmillcode/wml-components-base instead
  */
  generateClassPrefix= generateClassPrefix

  getWindow= ()=>{
    return window
  }

}



